/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AprilFoolType,
    AprilFoolTypeFromJSON,
    AprilFoolTypeFromJSONTyped,
    AprilFoolTypeToJSON,
} from './AprilFoolType';
import {
    BookmarkedPressReleaseAllOf,
    BookmarkedPressReleaseAllOfFromJSON,
    BookmarkedPressReleaseAllOfFromJSONTyped,
    BookmarkedPressReleaseAllOfToJSON,
} from './BookmarkedPressReleaseAllOf';
import {
    PressRelease,
    PressReleaseFromJSON,
    PressReleaseFromJSONTyped,
    PressReleaseToJSON,
} from './PressRelease';

/**
 * 
 * @export
 * @interface BookmarkedPressRelease
 */
export interface BookmarkedPressRelease {
    /**
     * プレスリリースID
     * @type {number}
     * @memberof BookmarkedPressRelease
     */
    pressReleaseId: number;
    /**
     * 企業ID
     * @type {number}
     * @memberof BookmarkedPressRelease
     */
    companyId: number;
    /**
     * タイトル
     * @type {string}
     * @memberof BookmarkedPressRelease
     */
    title: string;
    /**
     * 企業名
     * @type {string}
     * @memberof BookmarkedPressRelease
     */
    companyName: string;
    /**
     * 公開日時
     * @type {string}
     * @memberof BookmarkedPressRelease
     */
    publishedDatetime: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkedPressRelease
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof BookmarkedPressRelease
     */
    pressReleaseUrl: string;
    /**
     * 
     * @type {AprilFoolType}
     * @memberof BookmarkedPressRelease
     */
    aprilFoolType: AprilFoolType;
    /**
     * 保存済みかどうかを表すフラグ
     * @type {boolean}
     * @memberof BookmarkedPressRelease
     */
    isBookmarked: boolean;
}

export function BookmarkedPressReleaseFromJSON(json: any): BookmarkedPressRelease {
    return BookmarkedPressReleaseFromJSONTyped(json, false);
}

export function BookmarkedPressReleaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookmarkedPressRelease {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleaseId': json['press_release_id'],
        'companyId': json['company_id'],
        'title': json['title'],
        'companyName': json['company_name'],
        'publishedDatetime': json['published_datetime'],
        'thumbnailUrl': json['thumbnail_url'],
        'pressReleaseUrl': json['press_release_url'],
        'aprilFoolType': AprilFoolTypeFromJSON(json['april_fool_type']),
        'isBookmarked': json['is_bookmarked'],
    };
}

export function BookmarkedPressReleaseToJSON(value?: BookmarkedPressRelease | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_release_id': value.pressReleaseId,
        'company_id': value.companyId,
        'title': value.title,
        'company_name': value.companyName,
        'published_datetime': value.publishedDatetime,
        'thumbnail_url': value.thumbnailUrl,
        'press_release_url': value.pressReleaseUrl,
        'april_fool_type': AprilFoolTypeToJSON(value.aprilFoolType),
        'is_bookmarked': value.isBookmarked,
    };
}

